import ChallengeGroups from '@pages/challengeGroups/ChallengeGroups';
import ChallengeGroupChallenges from '@pages/challengeGroups/challenges/ChallengeGroupChallenges';
import CreateChallenge from '@pages/challengeGroups/challenges/CreateChallenge';
import ChallengeGroupChallenge from '@pages/challengeGroups/challenge/ChallengeGroupChallenge';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import EditChallenge from '@pages/challengeGroups/challenges/EditChallenge';
import ChallengeScoreSummary from '@pages/challengeGroups/challenge/challengeScoreSummary/ChallengeScoreSummary';

const ChallengeGroupsRoutes: React.FC = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path}>
                <ChallengeGroups />
            </Route>
            <Route exact path={`${path}/:id/challenges`}>
                <ChallengeGroupChallenges />
            </Route>
            <Route exact path={`${path}/:id/application-summary/:challengeid`}>
                <ChallengeScoreSummary />
            </Route>
            <Route exact path={`${path}/:id/challenges/create`}>
                <CreateChallenge />
            </Route>
            <Route exact path={`${path}/:id/challenges/:challengeid`}>
                <ChallengeGroupChallenge />
            </Route>
            <Route exact path={`${path}/:id/challenges/:challengeid/edit`}>
                <EditChallenge />
            </Route>
            <Route exact path={`${path}/:id/challenges/:action/:challengeID`}>
                <ChallengeGroupChallenges />
            </Route>
            <Route exact path={`${path}/:action`}>
                <ChallengeGroups />
            </Route>
            <Route exact path={`${path}/:action/:id`}>
                <ChallengeGroups />
            </Route>
        </Switch>
    );
};

export default ChallengeGroupsRoutes;
